import React, { useState, useContext, useRef, useEffect, useCallback } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import { DateTime } from "luxon";
import { useIntl, FormattedMessage } from "react-intl";

import UserContext from "../contexts/user";
import EventContext from "../contexts/event";

import SidebarMain from "../components/sidebar-main";
import SchedulePresentation from "../components/schedule/presentation";

import {
  EventData,
  ScheduleEndpointResponseObject,
  Version,
  VersionList,
} from "../types/presentation";
import EditProfileModal from "../components/edit-profile-modal";
import LocaleSwitcher from "../components/locale-switcher";
import PresentationItem from "../components/speaker/presentationItem";
import NewVideoItem from "./new-video-item";
import SidebarNewVideo from "../components/sidebar-new-video";
import ReactPlayer from "react-player";
import DocViewer from "react-doc-viewer";
import { IDocument } from "react-doc-viewer/build/types";
import { Document, Page } from "react-pdf";
import Slider from "react-slick";
import getEncodedImageUrl from "../helpers/get-encoded-image";
import SproutVideo from "../components/sprout-video";
import SliderCustom from "../components/custom-slider";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { useQuery, useQueryClient } from "react-query";
import axios from "axios";
import dayjs from "dayjs";
import useLocalStorage from "react-use-localstorage";

import { filter } from "lodash";
import { duration } from "../helpers/duration";
import Footer from "../components/footer";
import Plays from "../components/plays";
import Forum from "../components/forum";
import MobileBottomNav from "../components/mobile-bottom-nav";
import { BackArrow } from "../components/svgs";

const WatchSchedule: React.FC<{
  isSpeaker: boolean;
  eventData: EventData;
  locale: string;
  setLocale: (arg0: string) => void;
}> = ({ eventData, locale, setLocale, isSpeaker }) => {
  const { presentation_id, event_slug, version_id } = useParams<{
    presentation_id: string;
    event_slug: string;
    version_id: string;
  }>();

  const history = useHistory();

  const intl = useIntl();
  const location = useLocation();
  const userContext = useContext(UserContext);
  const eventContext = useContext(EventContext);
  const [isVirtual] = useState(
    queryString.parse(location.search).viewmode === "virtual"
  );
  const [isIframe] = useState(queryString.parse(location.search).iframe);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [uploadTab, setUploadTab] = useState("");
  const [singleVersion, setSingleVersion] = useState<Version>();
  const [rightVideo, setRightVideo] = useState("");
  const [leftVideo, setLeftVideo] = useState("");
  const [uploadDocument, setUploadDocument] = useState("");
  const [played, setPlayed] = useState(false);
  const [v, setV] = useState(null);
  const [w, setW] = useState(null);
  const [currentThumbnail, setCurrentThumbnail] = useState(0);
  const [swap, setSwap] = useState(false);
  const [cornerStyle, setCornerStyle] = useState({});
  const [progress, setProgress] = useState(0);
  const [skipVideo, setSkipVideo] = useState(0);
  const [enableRender, setEnableRender] = useState(false);
  const [playSlider, setPlaySlider] = useState(false);
  const [box, setBox] = useState("videos");
  const [visioEnabled, setVisioEnabled] = useState(true);
  const [viewFullSliders, setViewFullSliders] = useState(false);

  const [showForumSidebar, setShowForumSidebar] = useState(false);
  const [showMobileForumSidebar, setShowMobileForumSidebar] = useState(false);

  const [videoControlsHeight, setVideoControlsHeight] = useState(0);

  const [scrollPosition, setScrollPosition] = useState(0);
  const [presentationName, setPresentationName] = useState("");
  const [presentationDate, setPresentationDate] = useState("");
  const [roomName, setRoomName] = useState("");

  const [filter, setFilter] = useState<{
    speakers: Array<string>;
    rooms: Array<string>;
    associations: Array<string>;
    dates: Array<string>;
    activeQuizzesOnly: boolean;
  }>({
    speakers: [],
    rooms: [],
    associations: [],
    dates: [],
    activeQuizzesOnly: false,
  });
  let previousDate: string | null = null;
  const days = eventData.aggregates.dates.sort((a: string, b: string) =>
    a.localeCompare(b)
  );

  const handleVideoFile = (event: any) => {
    setRightVideo(URL.createObjectURL(event.target.files[0]));
  };



  const sliderRef = useRef() as React.MutableRefObject<Slider>;
  const screen = useFullScreenHandle();

  const handleScreen = () => {
    if (screen.active) {
      screen.exit();
    } else {
      screen.enter();
    }
  };

  const queryClient = useQueryClient();
  const [fetchData, setFetchData] = useState(false);
  const [eventPassword] = useLocalStorage(event_slug, "");
  console.log("eventPassword", eventPassword);
  let token: any = localStorage.getItem(`token-${event_slug}`);
  const [time, setTime] = useState("");

  // init load use effect callback
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // video page scroll handler function
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
    // getting page container
    const vTop = document.getElementById("video-mini-container");
    // @ts-ignore
    let height = vTop.offsetTop - position

    // getting page container
    const width = document.getElementsByClassName("logo-container")[0].clientWidth;
    // getting height aspect ratio based on element width
    const videoAspectHeight = (document.getElementsByClassName("logo-container")[0].clientWidth * 9) /
      16;
    // set video controller height
    setVideoControlsHeight(videoAspectHeight);
    setCornerStyle({
      position: "fixed",
      left: 0,
      top: height,
      width,
      zIndex: 99,
      height: videoAspectHeight,
    });
    console.log("handleScroll", width, videoAspectHeight, singleVersion)
  };

  useEffect(() => {
    // TODO
    const width =
      document.getElementsByClassName("logo-container")[0].clientWidth;
    // const height = document.getElementsByClassName('logo-container')[0].clientHeight;
    const vTop = document.getElementById("video-mini-container");
    const videoAspectHeight = singleVersion?.webcam?.id
      ? (document.getElementsByClassName("logo-container")[0].clientWidth * 9) /
      16
      : 0;
    setVideoControlsHeight(singleVersion?.webcam?.id ? videoAspectHeight : 0);
    setCornerStyle({
      position: "fixed",
      left: 0,
      top: vTop && vTop.offsetTop,
      width,
      zIndex: 99,
      height: videoAspectHeight,
    });
  }, [setCornerStyle, singleVersion]);



  const { data, isLoading, error } = useQuery(
    "event",
    async () => {
      const url =
        process.env.REACT_APP_API_ENDPOINT +
        "/api/public/schedule/" +
        event_slug;
      console.log("url in watch schedule ", url);

      const response = await axios.get<ScheduleEndpointResponseObject>(url, {
        params: { password: eventPassword },
      });
      return response.data;
    },
    {
      enabled: fetchData,
      onSuccess: (resp) => {
        const { event } = resp.data;
        console.log("event", event);

        resp.data.presentations.forEach((presentation) => {
          queryClient.setQueryData(["presentation", presentation._id], () => ({
            statusCode: 201,
            message: "event.fetch-success",
            data: { event, presentation },
          }));
        });
      },
    }
  );
  useEffect(() => {

    if (singleVersion == undefined) {
      axios
        .get<VersionList>(
          `
        ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/presentation/${presentation_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.log("REACT_APP_API_ENDPOINT", response);

          setPresentationName(response.data.data.name);
          setPresentationDate(`${response.data.data.date} ${response.data.data.time}-${response.data.data.end_time} `);
          getRoomData(response.data.data.room_id);

          let versionItem = response.data.data.versions.filter(function (
            version
          ) {
            return version.versionId == version_id;
          });

          if (versionItem.length) {
            setSingleVersion(versionItem[0]);


            let url = `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/video-details/${presentation_id}/video/${versionItem[0].video.id}`
            if (versionItem[0].webcam)
              url = `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/video-details/${presentation_id}/video/${versionItem[0].webcam.id}`

            axios
              .get(
                url,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then((response) => {
                console.log("versionItem 2", versionItem)
                console.log(
                  "response -----------------------------------------------------------------------------------------------------",
                  response.data.thumbnails[0]
                );
                setTime(response.data.duration);
              })
              .catch((error) => {
                console.log("versionItem 3", versionItem)

                console.log(error);
              });
          }

        })
        .catch((error) => {
          console.log(error);
        });
    }

  }, []);

  //get room detail from backend
  async function getRoomData(roomId: string) {
    axios({
      url: `${process.env.REACT_APP_API_ENDPOINT}/api/visio/room/${roomId}`,
      method: 'GET',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).then(value => {
      setRoomName(value.data.data.name);


    }).catch(reason => {
      console.log("getRoomData e", reason);
    }
    )
  }


  useEffect(() => {
    if (!singleVersion) {
      return;
    }
    let video: any = null;
    let webcam: any = null;
    if (singleVersion.video && singleVersion.video.id) {
      // @ts-ignore
      video = new global.SV.Player({ videoId: singleVersion.video.id });

      if (v == null) {
        setV(video);
      }
    }

    if (singleVersion.webcam && singleVersion.webcam.id) {
      // @ts-ignore
      webcam = new global.SV.Player({ videoId: singleVersion.webcam.id });
      if (w == null) {
        setW(webcam);
      }
    }

    if (video) {
      video.bind("ready", (e: any) => {
        console.log("debug: video ready");
      });
      video.bind("play", (e: any) => {
        console.log('videoplay: video play seek')


        setPlayed(true);
        if (webcam) {
          console.log('videoplay: webcam play seek', webcam, webcam.play())

          webcam.play();
        }
      });
      video.bind("pause", (e: any) => {
        //  console.log('debug: video pause')
        if (webcam) {
          webcam.pause();
        }
      });
      video.bind("progress", (e: any) => {
        console.log('debug: video ready', e.data.time)
        setProgress(e.data.time);
      });
    }

    if (webcam) {
      webcam.bind("progress", (e: any) => {
        if (
          video.getCurrentTime() + 0.5 < webcam.getCurrentTime() ||
          video.getCurrentTime() - 0.5 > webcam.getCurrentTime()
        ) {

          video.seek(e.data.time);
        }
      });
    }
  }, [singleVersion]);

  useEffect(() => {

    if (playSlider) {
      if (!singleVersion || !singleVersion.thumbnails) {
        return;
      }
      const thumbnail = singleVersion.thumbnails.findIndex(
        (t) => t.time > progress * 1000
      );

      if (sliderRef && sliderRef.current) {
        if (thumbnail === -1) {
          // end of ppt
          // @ts-ignore
          sliderRef.current.slickGoTo(singleVersion.thumbnails.length - 1);
          setCurrentThumbnail(singleVersion.thumbnails.length - 1);
        } else {
          // @ts-ignore
          sliderRef.current.slickGoTo(thumbnail === 0 ? 0 : thumbnail - 1);
          setCurrentThumbnail(thumbnail === 0 ? 0 : thumbnail - 1);
        }
      }
    }
  }, [progress, singleVersion, sliderRef]);



  const seekVideo = (value: any) => {


    // setProgress(value);

    if (w) {
      // if webcam is present, seek webcam, it will internally seek the video
      // @ts-ignore
      w.seek(value);

      // video.seek(value);
    } else {
      // if no webcam, seek the video
      if (v) {
        // @ts-ignore
        v.seek(value);

      }

    }
    if (!played) {
      if (v) {

        // @ts-ignore
        v.play();
      }
      if (w) {
        // if webcam is present, seek webcam, it will internally seek the video
        // @ts-ignore
        w.play();

        // video.seek(value);
      }

    }
    //}
    setEnableRender(enableRender => !enableRender);

  }
  // seek callback function for inner child components
  const seekVideoCallback = useCallback((value: any, videoRef: any, webcamRef: any) => {
    seekCustomVideo(value, videoRef, webcamRef)

  }, [enableRender]);

  // custom video seek function
  const seekCustomVideo = (value: any, videoRef: any, webcamRef: any) => {
    setEnableRender(enableRender => !enableRender);
    // check videoRef is not undefined
    if (videoRef) {
      // @ts-ignore
      videoRef.pause();
    }
    // check webcamRef is not undefined
    if (webcamRef) {
      // if webcam is present, seek webcam, it will internally seek the video
      // @ts-ignore
      webcamRef.pause();
    }
    // check webcamRef is not undefined
    if (webcamRef) {
      // if webcam is present, seek webcam, it will internally seek the video
      // @ts-ignore
      webcamRef.seek(value);
    }
    // check videoRef is not undefined
    if (videoRef) {
      // @ts-ignore
      videoRef.seek(value);
    }
    // check videoRef is not undefined
    if (videoRef) {
      // @ts-ignore
      videoRef.play();
    }
    // check webcamRef is not undefined
    if (webcamRef) {
      // if webcam is present, seek webcam, it will internally seek the video
      // @ts-ignore
      webcamRef.play();
    }
  }
  return (

    <FullScreen handle={screen}>
      <div className={`grid-contianer quiz-user-container video-grid-container`} style={{ gridTemplateColumns: " 300px 1fr" }}>
        <LocaleSwitcher locale={locale} setLocale={setLocale} />
        <div className="sidebar public-video-sidebar" >
          <div className="sidebar-main sidebar-new-video-main">
            <div className="logo-container videoPlayer-logo-container" style={{ padding: 'unset', paddingTop: '10px' }}>
              {!isIframe && (
                <div className="event-logo-container" style={{ padding: "10px" }}>
                  {eventData.event.logo && (
                    <img
                      height={60}
                      src={getEncodedImageUrl(eventData.event.logo, 110, 110, "contain")}
                      alt="logo"
                    />
                  )}
                  <span>{eventData.event.name}</span>
                </div>
              )}

              <div
                style={{ height: videoControlsHeight }}
                id="video-mini-container"
                className="video-mini-container d-none d-lg-block"
              >
                <div className="video-controls">
                  <Button
                    onClick={() => {
                      handleScreen();
                    }}
                    color="primary"
                  >
                    <img src="/icons/expand-1.svg" alt="expand" />
                  </Button>
                  {singleVersion?.webcam && singleVersion?.webcam.id && (
                    <Button
                      onClick={() => {
                        setSwap(!swap);
                      }}
                      className="m-l-10"
                      color="primary"
                    >
                      <img src="/icons/expand-2.svg" alt="expand" />
                    </Button>
                  )}
                </div>
              </div>




              <div className="profile-container profile-container-new-video">
                {userContext.user ? (
                  <div className="card mb-4">
                    <div className="d-flex align-items-center">
                      <div className="image profile-picture">
                        {userContext.user?.picture ? (
                          <img
                            height={50}
                            src={getEncodedImageUrl(
                              userContext.user?.picture,
                              110,
                              100,
                              "contain"
                            )}
                            alt="logo"
                            className="rounded profileImage"
                          />
                        ) : (
                          <img
                            src="/images/placeholder.svg"
                            className="rounded profileImage"
                            width="50"
                          />
                        )}

                        {/*
              <img src="/icons/profile-edit.svg" className="edit" width="20" alt="" />
*/}
                      </div>

                      <div className="ml-3 w-100 text-right welcome">
                        {/* eventtypography */}
                        <span className="mb-0 mt-0 welcometypography">Welcome</span>
                        {/* speaker name  */}
                        <h6 className="profileNameTypography">
                          {/* {allSpeakers[0].label} */}
                          {userContext.user.name}
                        </h6>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {/* check user authorize or not  */}
                {/* checking user is speaker or not if yes then show my presentation button */}
                {console.log("userContext.user", userContext.user)}

                {userContext.user?.is_speaker ? (
                  <div className="menu-conatiner">
                    <div className="presentation-menu">
                      <span className="title" style={{ textAlign: 'left', letterSpacing: '0px', color: '#ffffff', fontWeight: '600', fontSize: '1rem', display: 'flex' }}>{presentationName}</span>
                      <div className="d-flex">
                        <span className="date" style={{ fontSize: '1rem' }}>
                          {`${presentationDate}`}
                          {/* DATE 11h30 - 12h30 */}
                        </span>
                        <span className="room" style={{ fontSize: '1rem', textAlign: 'start' }}>{roomName}</span>
                      </div>
                    </div>

                    <div>
                      <Button
                        className={` change-text-second active`}
                        // nav-link active
                        onClick={function () {
                          history.push("/" + event_slug + "/my-presentations");
                        }}
                      >
                        <img src="/icons/back-blue.png" alt="presentations" />
                        <div>
                          <span className="text back-to-presentation">
                            <FormattedMessage id="menu.back.to.my.presentations" />
                          </span>
                        </div>
                      </Button>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <i className="bi bi-chevron-right"></i>
              </div>
              <div className="nav-conatiner d-none d-sm-block" style={{ padding: '0px', backgroundColor: '#32363f' }}>

                <div className="nav-container-box">
                  <Button
                    className="nav-link active nav-link-back-button"
                    onClick={() => setFilter({ ...filter, activeQuizzesOnly: false })}
                  >
                    <img src="/icons/back-arrow.svg" className="rounded " />
                  </Button>

                  <Button
                    className={`fade-color nav-link  disabled  ${box == "record" ? "active" : ""} `}
                    onClick={function () {
                      setFilter({ ...filter, activeQuizzesOnly: false });
                      //setBox("record");
                      console.log("--------------------box", box);
                    }}
                  >
                    <img src="/icons/record-video.svg" alt="schedule" />
                    <span className="text">
                      <FormattedMessage id="menu.record.video" />
                    </span>
                    {box == "record" ? <div className="rectangular-box"></div> : ""}
                  </Button>

                  <Button
                    className={`${visioEnabled ? "" : "fade-color disabled"} nav-link   ${box == "live" ? "active" : ""} `}
                    onClick={function () {
                      if (visioEnabled) {
                        // setFilter({...filter, activeQuizzesOnly: false});
                        window.open(`${process.env.REACT_APP_VISIO}/visio/${presentation_id}/${userContext.user?.id}`, '_self')
                      }
                    }}
                  >
                    <img src="/icons/live-stream.svg" alt="schedule" />
                    <span className="text">
                      <FormattedMessage id="menu.live.stream" />
                    </span>
                    {/* <div className="rectangular-box"></div> */}
                    {box == "live" ? <div className="rectangular-box"></div> : ""}
                  </Button>


                  <Button
                    // className={`nav-link ${filter.activeQuizzesOnly ? "" : "-active"}`}
                    className={`nav-link   ${box == "videos" ? "active" : ""} `}

                    // className="nav-link active"
                    // onClick={() => setFilter({ ...filter, activeQuizzesOnly: false })}
                    onClick={function () {
                      setFilter({ ...filter, activeQuizzesOnly: false });
                      setBox("videos");
                      history.push({
                        pathname: `/${eventContext.slug}/my-presentations/${presentation_id}/videos`,
                        state: { presentationName }
                      })
                    }}
                  >
                    <img src="/icons/my-videos.svg" alt="schedule" />
                    <span className="text">
                      <FormattedMessage id="menu.my.videos" />
                    </span>

                    {box == "videos" ? <div className="rectangular-box"></div> : ""}
                    {/* <div className="rectangular-box"></div> */}
                  </Button>
                </div>
              </div>
            </div>

            <div style={{ height: '200px', marginTop: '50px' }}>
              <Footer />
            </div>



            <div
              className={`forum-container-sidebar ${showForumSidebar ? "show-forum" : ""
                }`}
            >

            </div>
          </div>

        </div>

        <div className="main video-main-bot-fix relative overflow-div">
          <Container fluid>

            <Col>
              <div className="d-flex bd-highlight watch-header">
                <div className="p-2 flex-grow-1 bd-highlight">
                  <div className="back-to-videos">
                    <a
                      style={{ cursor: 'pointer', textDecoration: 'none' }}
                      onClick={function () {
                        history.push(
                          `/${eventContext.slug}/my-presentations/${presentation_id}/videos`
                        );
                      }}
                    >
                      <img
                        src="/icons/back-blue.png"
                        alt="presentations"
                      />
                      <span className="text" style={{ paddingLeft: '10px', color: '#24b2ff', textTransform: 'uppercase' }}>
                        <FormattedMessage id="menu.back.to.my.videos" />
                      </span>
                    </a>
                  </div>
                </div>

                <div className="p-2 bd-highlight">
                  <div className="d-flex bd-highlight ">

                    <div className="time" style={{ color: '#a5a8af' }}>
                      <span>Duration : {time ? duration(time) : "Loading.."}</span>
                    </div>
                    <div className="d-flex date" style={{ flexDirection: 'column', marginLeft: '19px', color: '#4b4f5a', fontWeight: 'bold' }}>
                      <span>
                        {dayjs(singleVersion?.date).format("h:mm A")}
                      </span>
                      <span>
                        {dayjs(singleVersion?.date).format("DD/MM/YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>


            <div className={`row ${showForumSidebar ? "show-forum-sidebar-mobile show-forum-sidebar-mobile-hide" : ""}`} style={showForumSidebar ? {} : { display: "flex", justifyContent: "center" }}>
              <Col lg={8}>

                <div
                  className={
                    swap
                      ? showForumSidebar
                        ? "video-big-container-forum-action"
                        : "video-big-container "
                      : "mini-player"
                  }
                  style={swap ? {} : cornerStyle}
                >
                  {!swap ? (
                    <div
                      onClick={() => {
                        if (v !== null) {
                        }
                      }}
                      className="overlay"
                    ></div>
                  ) : null}

                  {singleVersion?.webcam && singleVersion?.webcam.id && (
                    <SproutVideo
                      {...singleVersion?.webcam}
                      skip={0}
                      className="video"
                      volume={1}
                      bigPlayButton={false}
                      showcontrols={false}
                      seekBar={false}
                    />
                  )}
                </div>

                <div
                  className={
                    swap ? "mini-player" : showForumSidebar ? "video-big-container-forum-action" : "video-big-container"

                  }
                  style={swap ? cornerStyle : {}}
                >
                  {singleVersion?.video ? (
                    <SproutVideo
                      {...singleVersion?.video}
                      skip={0}
                      className="video"
                      bigPlayButton={true}
                      volume={
                        singleVersion?.webcam && singleVersion?.webcam.id ? 0 : 1
                      }
                      showcontrols={true}
                    />
                  ) : (
                    <div style={showForumSidebar ? { textAlign: "center", paddingTop: "30vh", paddingRight: "20vh" } : { textAlign: "center", padding: "30vh" }}><i>No video</i></div>
                  )}
                </div>
              </Col>
            </div>

            <div className={`row ${showForumSidebar ? "show-forum-sidebar-mobile show-forum-sidebar-mobile-hide" : ""}`} style={showForumSidebar ? {} : { display: "flex", justifyContent: "center" }}>

              <Col lg={8}>

                <div className={`video-header-panel d-none d-sm-block`}  >
                  <span></span>
                </div>


                <div className={`d-none d-sm-block`}>
                  <a className={`slide-video-button `} onClick={event1 => setViewFullSliders(!viewFullSliders)}>
                    <span className={`link`}>{!viewFullSliders ? intl.formatMessage({ id: 'video.all.sliders' }) : intl.formatMessage
                      ({ id: 'video.hide.sliders' })}</span>
                  </a>
                </div>

                {/* all slides enable button */}
                {singleVersion?.video && (
                  <div
                    className={`
                    ${showForumSidebar
                        ? "slides-summary-forum-action"
                        : " slides-summary"
                      }
                    `}

                  >


                    {/*show screen slider video components*/}
                    {!viewFullSliders && v && sliderRef ? <SliderCustom videoRef={v} webcamRef={w} sliderRef={sliderRef} enableRender={enableRender} seekVideo={seekVideoCallback} singleVersion={singleVersion} currentThumbnail={currentThumbnail} /> : ""
                    }


                    {/* slider all components view */}
                    {viewFullSliders && (<div className="">

                      <div className="slides-all-container">
                        {singleVersion?.thumbnails &&
                          singleVersion?.thumbnails
                            .sort((a, b) => a.time - b.time)
                            .map((thumbnail, index) => (
                              <a
                                key={thumbnail.time}
                                data-time={thumbnail.time}
                                href="/"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setCurrentThumbnail(index);
                                  seekVideoCallback(thumbnail.time / 1000, v, w);

                                }}
                                className={`item ${currentThumbnail === index ? "active-slide" : ""} pb-2`}
                              >
                                <div className="m-10">
                                  <img
                                    className="img-fluid"
                                    src={getEncodedImageUrl(
                                      thumbnail.id.indexOf("e-slides.net") > -1
                                        ? thumbnail.id.split("e-slides.net/")[1]
                                        : thumbnail.id,
                                      150,
                                      61
                                    )}
                                    alt={`Slide ${index + 1}`}
                                  />
                                </div>
                              </a>
                            ))}
                      </div>

                    </div>)}


                    {/* slider  mobile view */}
                    <div className="d-block d-lg-none">
                      <div className="slides-mob-container">
                        {singleVersion?.thumbnails &&
                          singleVersion?.thumbnails
                            .sort((a, b) => a.time - b.time)
                            .map((thumbnail, index) => (
                              <a
                                key={thumbnail.time}
                                data-time={thumbnail.time}
                                href="/"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setCurrentThumbnail(index);
                                  seekVideoCallback(thumbnail.time / 1000, v, w);

                                }}
                                className={`item ${currentThumbnail === index}`}
                              >
                                <div className="m-10">
                                  <img
                                    className="img-fluid"
                                    src={getEncodedImageUrl(
                                      thumbnail.id.indexOf("e-slides.net") > -1
                                        ? thumbnail.id.split("e-slides.net/")[1]
                                        : thumbnail.id,
                                      274,
                                      174
                                    )}
                                    alt={`Slide ${index + 1}`}
                                  />
                                </div>
                              </a>
                            ))}
                      </div>
                    </div>

                  </div>


                )}

              </Col>

            </div>



          </Container>
        </div>
      </div>
    </FullScreen>
  );
};
export default WatchSchedule;

